import { render, staticRenderFns } from "./user-management-page.vue?vue&type=template&id=a68262b0&"
import script from "./user-management-page.vue?vue&type=script&lang=js&"
export * from "./user-management-page.vue?vue&type=script&lang=js&"
import style0 from "./user-management-page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports